var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert mb-0",class:'alert-' + _vm.type},[(_vm.exclaim)?_c('i',{staticClass:"fa fa-exclamation-circle",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.info)?_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }